import { createSelectorCreator } from 'reselect';
import { reduce, memoize } from 'lodash';
import getCampaignObject from './getCampaignObject';

const createDeepEqualSelector = createSelectorCreator(memoize, (...args) =>
  args.reduce((acc, val) => `${acc}-${JSON.stringify(val)}`, '')
);

export default (state) => getCampaignObject(state).supplier;
